import { authStorage } from './auth-storage';

export const initializeClientAuth = (userToken: string, uid: number) => {
  // client-side 의 authStorage instance 에 사용자 토큰 주입
  authStorage.setToken(userToken);
  authStorage.setUid(uid);
};
